const SCOPE = 'notification-filter';

const getSlug = value => (value == null ? 'all' : String(value).toLowerCase());

export const PushNotificationFilterBarTestIds = {
  getTypeChipId: value => `${SCOPE}.type-${getSlug(value)}-button`,
  getSourceChipId: value => `${SCOPE}.source-${getSlug(value)}-button`,
};
